import React, {useEffect, useState} from 'react';
import {Link, RouteComponentProps} from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import {ISSRData, Property} from "../interfaces";
import {useAxios} from "../useHooks/useAxios";
import {IResponse} from "../interfaces/response.interface";
import service from "../services/service";


interface IPortfolioItemPageProps extends RouteComponentProps<any> {
    ssrData: ISSRData;
}

const PortfolioItemPage = (props) => {
    const {match, ssrData} = props as IPortfolioItemPageProps;
    const {id, index} = match.params;
    const {property} = (ssrData || {}) as ISSRData;
    const isMatchedPropertyWithIndex = property && property.documentId === index;

    const [item, setItem] = useState<Property | undefined>(isMatchedPropertyWithIndex ? property : undefined);
    const {data, request} = useAxios<IResponse<Property>>(service.getProperty);

    useEffect(() => {
        if ((!property || !isMatchedPropertyWithIndex)) {
            request(index);
        }
    }, [property, request]);

    useEffect(() => {
        if (data) setItem(data.data);
    }, [data]);

    useEffect(() => {
        const staticPath = process.env.PUBLIC_URL + '/js/';

        if(item){
            let contactSelect = document.createElement('script');
            contactSelect.src = staticPath + 'owlCarousel' + '.js';
            contactSelect.id = 'owlCarousel';
            document.body.appendChild(contactSelect);

            return () => {
                contactSelect.remove();
            };
        }

        return () => {};
    }, [item]);

    return (
        <div className="page-bg">
            <div className="page page-portfolio">
                <Header/>
                {item && <main className="portfolio-page_one">
                    <div className="container">
                        <p className="back-link"><Link to={'/portfolio/' + id}><span>Retour au portfolio</span></Link>
                        </p>
                        <h1>{item.title}</h1>
                        {item.description}
                        {item.link &&
                            <p><a href={item.link} className="info-link" target={'_blank'}>Infos vente</a></p>
                        }
                        <div id="sync1" className="owl-carousel owl-theme portfolio-slider-big">
                            {
                                item.images?.map((img, i) => (
                                    <div key={i} className="item">
                                        <figure className="portfolio-big"><img src={img.url}/></figure>
                                    </div>
                                ))
                            }
                        </div>

                        <div id="sync2" className="owl-carousel owl-theme portfolio-slider-thumb">
                            {
                                item.images?.map((img, i) => (
                                    <div key={i} className="item">
                                        <figure className="carousel-pic"><img src={img.url}/></figure>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </main>}

                <section className="section-conseil">
                    <div className="container">
                        <Link to={'/conseil'}>
                            <figure className="section-conseil_pic"><img
                                src={require('../assets/images/expertise.svg')}/></figure>
                        </Link>
                    </div>
                </section>

                <Footer/>
            </div>
        </div>
    )
};

export default PortfolioItemPage;
